import { extrairValorArquivo } from '@/utils/produtoImagem'

export async function uploadRegistrationImage(axios, urlRest, companyId, file, pasta = 'produtos') {
  if (!String(file && file.type || '').startsWith('image/')) throw new Error('Selecione um arquivo de imagem válido.')
  const dataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = event => resolve(event.target.result)
    reader.onerror = () => reject(new Error('Não foi possível ler a imagem.'))
    reader.readAsDataURL(file)
  })
  const response = await axios.post(urlRest + 'upload', { pasta, dataUrl }, { headers: { 'X-Company-Id': companyId } })
  const reference = extrairValorArquivo(response.data)
  if (!reference) throw new Error('O envio não retornou a referência da imagem.')
  return reference
}
